import React, { Component } from "react";
import Loader from "react-loader-spinner";

import "./Loading.css";

class Loading extends Component {
  render() {
    let message = this.props.message ? this.props.message : "Loading";
    return (
      <div className="loading" hidden={this.props.hidden}>
        <div>
          <Loader
            type="TailSpin"
            color="rgb(56, 56, 56)"
            height={25}
            width={25}
          />
          <div className="loader-text">
            {message}
            ...
          </div>
        </div>
      </div>
    );
  }
}

export default Loading;
